const DAY = 86_400_000;
const HOUR = 3_600_000;

export function toInput(instant: Date, offsetMinutes = -new Date().getTimezoneOffset()): string {
  const wall = new Date(instant.getTime() + offsetMinutes * 60_000);
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${wall.getUTCFullYear()}-${pad(wall.getUTCMonth() + 1)}-${pad(wall.getUTCDate())}T${pad(wall.getUTCHours())}:${pad(wall.getUTCMinutes())}`;
}

export function fromInput(said: string, offsetMinutes = -new Date().getTimezoneOffset()): Date | null {
  const found = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(said.trim());
  if (!found) return null;
  const [, year, month, day, hour, minute] = found;
  const parts = [year, month, day, hour, minute].map(Number);
  if (parts.some((one) => !Number.isInteger(one))) return null;
  const instant =
    Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute)) -
    offsetMinutes * 60_000;
  const held = new Date(instant);
  if (Number.isNaN(held.getTime())) return null;
  return toInput(held, offsetMinutes) === `${year}-${month}-${day}T${hour}:${minute}` ? held : null;
}

export { DAY, HOUR };
